import { render, staticRenderFns } from "./SettingsTablePotentialLeadsSidebar.vue?vue&type=template&id=ea6911aa"
import script from "./SettingsTablePotentialLeadsSidebar.vue?vue&type=script&lang=js"
export * from "./SettingsTablePotentialLeadsSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports